module.exports = require("@swa-ui/personal-info");